import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { AUTH_KEYS, AuthProvider, LoginType } from "../interfaces/auth-response";
import { EntraIdProvider } from "../providers/authentication/entra-id.provider";
import { CustomAuthProvider } from "../providers/authentication/custom-auth.provider";
import { AuthOtpProvider } from "../providers/authentication/auth-otp.provider";
import { AzureProvider } from "../providers/authentication/azure.provider";
import { RoleSimulationService } from "./role-simulation.service";

@Injectable({ providedIn: 'root' })
export class AuthService {

    constructor(
        private entraidProvider: EntraIdProvider,
        private otpProvider: AuthOtpProvider,
        private customAuthProvider: CustomAuthProvider,
        private azureProvider: AzureProvider,
        private roleSimulationService: RoleSimulationService,
    ) { }

    login(type: LoginType, creds?: any) {
        switch (type) {
            case LoginType.ENTRA_ID:
                return this.entraidProvider.login();
            case LoginType.OTP:
                return this.otpProvider.login(creds);
            case LoginType.CUSTOM:
                return this.customAuthProvider.login(creds);
            case LoginType.AZURE:
                return this.azureProvider.login();
            default:
                throw new Error('Provider di autenticazione non trovato.');
        }
    }

    completeAzureLogin(code: string, state: string) {
        return this.azureProvider.completeLogin(code, state);
    }

    private get activeProvider(): AuthProvider | null {
        const type = localStorage.getItem(AUTH_KEYS.LOGIN_TYPE) as LoginType;
        switch (type) {
            case LoginType.ENTRA_ID:
                return this.entraidProvider;
            case LoginType.OTP:
                return this.otpProvider;
            case LoginType.CUSTOM:
                return this.customAuthProvider;
            case LoginType.AZURE:
                return this.azureProvider;
            default:
                return null;
        }
    }

    getToken() { 
        return this.activeProvider?.getToken() || of(null); 
    }

    isLoggedIn() { 
        return this.activeProvider?.isLoggedIn() || of(false); 
    }

    logout() {
        if (this.roleSimulationService.simulatedUser()) {
            this.roleSimulationService.terminate().subscribe();
        }
        this.activeProvider?.logout();
    }
}
